import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import Sanitize      from '@utils/sanitize';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class DraftContentsAfterResive extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      show: false
    };
  }
  // -------------------------------------------------------
  
  toggleShow(ng_count) {
    let flg = (this.state.show == true) ? false : true;
    if( flg == true && ng_count == 0 ) return;
    
    this.setState({ show: flg });
  }
  // -------------------------------------------------------
  
  render() {
    let contents = this.props.contents;
    let detail   = this.props.detail;
    let table    = this.props.table;
    
    if( detail.my_authority !== 99 ) return null;
    
    // メンバー数が1人以下の場合は対応しない
    if( detail.draft_management.accounts.length <= 1 ) return null;
    
    let management = {};
    try { management = Utils.createColumnObject(detail.draft_management.accounts, 'user_id'); } catch(e) {}
    
    let revise = [];
    detail.draft_revise.map((d) => {
      if( table == 'draft_caption' && d.contents_id == contents.id && d.media_id == null ) revise.push(d);
      if( table == 'draft_media'   && d.contents_id == contents.contents_id && d.media_id == contents.id ) revise.push(d);
    });
    
    let ok_member = [];
    let ng_member = [];
    revise.map((d) => {
      if( management[d.user_id] == undefined ) return;
      
      d.user = management[d.user_id];
      if( d.is_approval == 0 ) ng_member.push(d);
      if( d.is_approval == 1 ) ok_member.push(d);
    });
    
    let ok_class = (ok_member.length > 0) ? 'on': 'off';
    let ng_class = (ng_member.length > 0) ? 'on': 'off';
    
    let ok_help = <HelpHtml title="[内容OK]" members={ok_member} />
    let ng_help = <HelpHtml title="[修正依頼]" members={ng_member} />
    
    console.log(detail.draft_logs);
    
    return (
      <div className="draft-after-revise">
        <div className="draft-after-revise-items">
          <p className="revise-title">確認結果</p>
          <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>{ok_help}</Tooltip>}>
            <div className={'ok-box '+ ok_class}>
              <i className="material-icons">check_circle</i>{ok_member.length}人
            </div>
          </OverlayTrigger>
          
          <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>{ng_help}</Tooltip>}>
            <div className={'ng-box '+ ng_class} onClick={this.toggleShow.bind(this, ng_member.length)}>
              <i className="material-icons">cancel</i>{ng_member.length}人
              { (ng_member.length > 0) && <span>{(this.state.show == true) ? '詳細を閉じる' : '詳細をこちら' }</span> }
            </div>
          </OverlayTrigger>
        </div>
        
        { (this.state.show == true) &&
          <ul className="ng-revise-messages">
            { ng_member.map((d, key) => {
              
              // キャプション
              let msg = null;
              try { if( d.revise_message != undefined && d.revise_message != null ) msg = Sanitize.nl2br(d.revise_message); } catch(e) {}
              
              return (
                <li key={key}>
                  <p>{d.user.name} ({d.user.email})</p>
                  <div className="ng-revise-message-box" dangerouslySetInnerHTML={{ __html: msg }} />
                </li>
              );
            })}
          </ul>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

class HelpHtml extends React.Component {
  render() {
    let help_style = { textAlign: 'center', marginBottom: '10px' };
    
    if( this.props.members.length > 0 ){
      return (
        <div>
          <h4 style={help_style}>{this.props.title}</h4>
          {this.props.members.map((d, key) => { return <p key={key}>{d.user.name} ({d.user.email})</p>; })}
        </div>
      );
    } else {
      return (
        <div>
          <h4 style={help_style}>{this.props.title}</h4>
          <p>対象がいません</p>
        </div>
      );
    }
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftContentsAfterResive;